/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_ColorInputs */

const en_tables_rule_sets_color = /** @type {(inputs: Tables_Rule_Sets_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Color`)
};

const de_tables_rule_sets_color = /** @type {(inputs: Tables_Rule_Sets_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Sets Color" |
*
* @param {Tables_Rule_Sets_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_color = /** @type {((inputs?: Tables_Rule_Sets_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_color(inputs)
	return de_tables_rule_sets_color(inputs)
});